import React from 'react';

export default (Component, Context) => {
	return (props) => (<Context.Consumer>    
		{(context) => {
			 return <Component {...props} context={context} />
		}}
	</Context.Consumer>)
}
